module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Hat-c0c81a0688376a42afa0d9bb3dbb7f3c.svg";